import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  Link, useNavigate, useParams } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { Pagination } from '../../components/Pagination';

import useQueryString from '../../../utils/hooks/useQueryString';
import { fetchRecommendSchoolList } from '../ducks/schoolRecommendList';
const queryString = require('query-string');

const SchoolRecommendList = ()=>{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { school } = useParams();
    const { id, page } = useQueryString();
    const schoolRecommendList = useSelector(state => state.schoolRecommendList);

    useEffect(() => {
        dispatch( fetchRecommendSchoolList( (page===undefined)?0:page ) );
    }, [dispatch, page]);

    function fetchList(page=0) {
        let tempSearchOption = {id, page };
        navigate(`/${window.schoolCode}/recommend/school?${queryString.stringify(tempSearchOption)}`);
    }

    if(schoolRecommendList.list == null) return;
    if(schoolRecommendList.list.length<=0)return <div className="no_data"><p>결과가 없습니다.</p></div>;
    
    const schoolList = schoolRecommendList.list.map((recommend, key) => {
        return (
            <Link key={key} className={`btn _sm _white ${( id!==undefined && recommend.id===parseInt(id, 10))?'on':''}`} 
                    to={`/${school}/recommend/school?id=${recommend.id}&page=${page}`} >
                {recommend.title}
            </Link>
        );
    });
    
    return (
    <div className="btn_wrap">
        {schoolList}
        <Loading overlay={true} active={schoolRecommendList.loading} />
        <Pagination page={schoolRecommendList.page} totalPage={schoolRecommendList.totalPages} gotoPage={fetchList} />
    </div>
    );
}// end class
export default SchoolRecommendList;